
const payableListQuery = `
  with location_base as (
    select
      uuid as location_id
    from avocado.data_location
    where uuid = $1
  ),
  location_transactions as (
    select
      qt.transaction_uuid as id,
      qt.location_id,
      qt.company_code,
      qt.txn_id,
      qt.description,
      qt.code,
      qt.order_type,
      qt.created_at,
      qt.updated_at,
      qt.payment_plan_id,
      case
        when qt.txn_type = 'instalment' then 'installment'
        else qt.txn_type
      end as txn_type,
      qt.amount,
      qt.paid_amount,
      qt.due_date,
      qt.txn_date,
      qt.doc_number as quickbooks_doc_number,
      row_to_json(pp.*)::jsonb as payment_plan,
      case
        when qt.txn_type in ('invoice', 'instalment', 'refund') then 'debit' 
        else 'credit'
      end as posting_type
    from location_base lb
    cross join avocado.get_quickbookstransactions_by_location(lb.location_id) qt
    left join avocado.data_paymentplan pp on pp.id = qt.payment_plan_id::uuid
    where qt.company_code in ('NG', 'KE') AND
      "txn_type" in ('invoice', 'instalment', 'payment' )
  ),
  pending AS (
    SELECT
      p.id,
      p.location_id,
      due_date,
      -- The amount from paystack is in the currencies subunit, convert to main unit
      case when p.total_amount > 0 then p.total_amount
      else p.amount_in_cents / 100  end as amount,
      null::float as amount_paid,
      null AS description,
      'pending invoice payment' AS txn_type,
      quickbooks_doc_number,
      p.updated_at::date as txn_date,
      p.created_at,
      p.updated_at,
      null as order_type,
      null::jsonb AS payment_plan,
      null as company_code,
      null as txn_id
    FROM location_base lb
    inner join avocado.data_payment p on p.location_id = lb.location_id 
    LEFT JOIN location_transactions t
      ON t.txn_type = 'payment'
     AND t.description = "p"."payment_data" ->> 'reference'
     AND t.location_id = p.location_id
    WHERE (p.status = 'success' OR p.status = 'client_side_paid')
    and p.payment_method != 'credit' -- we need exclude credits from pending payments list
    and t.id IS NULL
    -- Payments made prior to the specified date should not be included in the pending payment logic.
    and p.created_at > '2023-06-08'

    UNION

    SELECT
      p.id,
      p.location_id,
      due_date,
      -- The amount from paystack is in the currencies subunit, convert to main unit
      p.amount_in_cents / 100 as amount,
      null::float as amount_paid,
      p.payment_data ->> 'reference' AS description,
      case 
        when p.qbo_txn_id is not null and p.qbo_company_code is not null then 'pending invoice payment'
        else 'pending installment payment'
      end as txn_type,
      quickbooks_doc_number,
      p.updated_at::date as txn_date,
      p.created_at,
      p.updated_at,
      null as order_type,
      null::jsonb AS payment_plan,
      p.qbo_company_code as company_code,
      p.qbo_txn_id as txn_id
    FROM location_base lb 
    inner join avocado.data_paygcreditpayment p on p.location_id = lb.location_id
    left join location_transactions t on
      t.txn_type = 'payment' and
      t.description = p.payment_data ->> 'reference'
    WHERE t.id is null
  ),
  transactions as (
    SELECT
      tl.id,
      tl.location_id,
      tl.due_date,
      tl.amount,
      tl.amount_paid,
      tl.description,
      tl.txn_type,
      tl.quickbooks_doc_number,
      tl.txn_date,
      tl.created_at,
      tl.updated_at,
      tl.order_type,
      tl.payment_plan,
      tl.posting_type,
      tl.code,
      tl.shipment_id,
      tl.order_id,
      p.amount as pending_payment_amount
    FROM (
      SELECT
        t.id,
        t.location_id,
        t.due_date,
        abs(t.amount) as amount,
        t.paid_amount as amount_paid,
        t.description,
        t.txn_type,
        t.quickbooks_doc_number,
        t.txn_date,
        t.created_at,
        t.updated_at,
        t.order_type,
        t.payment_plan,
        t.posting_type,
        t.code,
        t.txn_id,
        t.company_code,
        il.shipment_id,
        il.order_id
      from location_transactions t
      left join avocado.data_invoicepaymentplan ip on ip.paymentplan_id = (t.payment_plan ->> 'id')::uuid
      left join avocado.data_invoice_quickbooks iq on
        (iq.invoice_txn_id = t.txn_id and iq.company_code = t.company_code) or
        (iq.invoice_txn_id = ip.qbo_txn_id and iq.company_code = ip.qbo_company_code) or
        (iq.creditmemo_txn_id = t.txn_id and iq.company_code = t.company_code)
      left join lateral (
        select
          il.invoice_id,
          il.shipment_id,
          il.order_id
        from avocado.data_invoice_line il
        where il.invoice_id = iq.invoice_id and
         (il.shipment_id IS NOT NULL OR il.order_id IS NOT NULL)
        LIMIT 1
      ) il ON true
      where t.txn_type in ('invoice', 'installment')  AND
      ( abs(coalesce(amount, 0)) - coalesce(paid_amount, 0) ) > 0
    ) tl
    LEFT OUTER JOIN pending p ON p.location_id = tl.location_id
     AND 
    (p.quickbooks_doc_number = tl.quickbooks_doc_number or 
      (p.quickbooks_doc_number = tl.code AND p.payment_plan ->> 'id' = tl.payment_plan ->> 'id') or
      (p.description = tl.description) or
      (p.txn_id = tl.txn_id and p.company_code = tl.company_code)
    )
  ),
  overdue_transactions AS (
    SELECT
      'overdue' AS week,
      coalesce (jsonb_agg(t order by t.due_date desc, t.txn_type asc), '[]'::jsonb) AS transactions,
      coalesce (sum(amount - coalesce(amount_paid, 0)), 0) AS totalDue,
      coalesce (sum(coalesce(pending_payment_amount, 0)), 0) as "pendingPayments"
    FROM transactions t
    WHERE due_date < current_date and (amount - amount_paid) <> 0
  ),
  weekly_transactions AS (
    SELECT
      CASE
        WHEN (extract (day from date_trunc('week', due_date) - date_trunc('week', CURRENT_TIMESTAMP))::integer / 7) < 0 THEN '0'
        ELSE (extract (day from date_trunc('week', due_date) - date_trunc('week', CURRENT_TIMESTAMP))::integer / 7)::text
      END AS week,
      jsonb_agg(t order by t.due_date desc, t.txn_type asc) AS transactions,
      sum(amount - coalesce(amount_paid, 0)) AS totalDue,
      sum(coalesce(pending_payment_amount, 0)) as "pendingPayments"
    FROM transactions t 
    WHERE due_date >= current_date and (amount - amount_paid) <> 0
    group by week order by week
  )
  SELECT
    ot.week,
    ot.transactions,
    ot.totaldue,
    ot."pendingPayments",
    ot.totaldue - ot."pendingPayments" as "pendingBalance"
  FROM overdue_transactions ot

  UNION ALL

  select
    wt.week,
    wt.transactions,
    wt.totaldue,
    wt."pendingPayments",
    wt.totaldue - wt."pendingPayments" as "pendingBalance"
  FROM weekly_transactions wt
`

module.exports = payableListQuery
